<template>
	<div id="cc_left1">
		<div class="cc-header">课程分类</div>
		<div class="main-value" id="course_class"></div>
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgCode = storage.getItem("orgCode");
	const echarts = require("echarts");
	export default {
		mounted() {
			this.initData();
			// 定时器刷新，1天
			let _this = this;
			setInterval(() => {
				_this.initData();
			}, 1000 * 60 * 60 * 24);
		},
		methods: {
			initData() {
				let myChartPieLeft = echarts.init(
					document.getElementById("course_class")
				);
				this.$http.get("/dataView/clubClass/edu/getCourseTagRatio?orgCode=" + orgCode).then(res => {
					if (res.data.code === 200) {
						var result = [];
						for (var i = 0; i < res.data.result.length; i++) {
							var obj = res.data.result[i];
							result.push({ name: obj.tag, value: obj.count });
						}
						var option = {
							tooltip: {
								trigger: 'item'
							},
							legend: {
								show: false,
								textStyle: {
									fontSize: fontSize(0.15),
									height: 13,
									rich: {
										a: {
											verticalAlign: 'middle'
										}
									},
									color: '#34deff' // 把颜色这里做成函数就可以了
								},
								bottom: '0',
								itemWidth: 15,
								itemHeight: 13
							},
							series: [{
								name: '',
								type: 'pie', //饼状图
								radius: ['30%', '55%'],
								data: result,
								itemStyle: {
									normal: {
										label: {
											show: true,
											textStyle: {
												color: '#34deff',
												lineHeight: 18,
												fontSize: fontSize(0.15)
											},
											formatter: '{b} : {c} '
										},
										labelLine: { //指示线状态
											show: true,
										}
									}
								}
							}]
						};
						myChartPieLeft.hideLoading(); //没有加载出来隐藏加载动画
						myChartPieLeft.setOption(option);
						// 响应式变化
						window.addEventListener("resize", () => myChartPieLeft.resize(), false);
					}
				});
			}

		},
		destroyed() {
			window.onresize = null;
		}
	};

	function fontSize(res) {
		let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (!clientWidth) return;
		let fontSize = 100 * (clientWidth / 1920);
		return res * fontSize;
	}
</script>

<style lang="scss">
	#cc_left1 {
		height: 100%;
		.cc-header {
			width: 100%;
			text-align: center;
			background: url("../../assets/img/ac_titbgsmall.png") center no-repeat;
			background-size: 100%;
			color: #0ef3ff;
			font-size: 0.22rem;
			font-weight: bold;
			height: 0.8rem;
			line-height: 0.6rem;
		}

		.main-value {
			height: 85%;
		}

	}
</style>